
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { getVoteList } from '../api';
import ActivityHeader from '../components/ActivityHeader.vue';
@Component({
  components: {
    ActivityHeader,
  },
})
export default class Success extends Vue {
  vote: { date: string; cq: string[]; sc: string[] } = {
    date: '',
    cq: [],
    sc: [],
  };
  message = '';
  async created() {
    let ids: number[] = [];
    try {
      const rawIds = sessionStorage.getItem('20260901JQDM_SUCCESS_IDS');
      const parsedIds = rawIds ? JSON.parse(rawIds) : [];
      ids = Array.isArray(parsedIds) ? parsedIds.map(Number) : [];
    } catch (error) {
      this.message = '点名结果读取失败，请返回重试';
      return;
    }
    if (!ids.length) {
      this.$router.push('/20260901JQDM/home');
      return;
    }
    try {
      const res: any = await getVoteList();
      const data = res.data || res;
      const findNames = (list: any[]) =>
        (Array.isArray(list) ? list : [])
          .filter((item) => ids.indexOf(Number(item.id)) > -1)
          .map((item) => item.name);
      this.vote.cq = findNames(data.Chongqing);
      this.vote.sc = findNames(data.Sichuan);
    } catch (error) {
      this.message = '景区名称加载失败，请稍后重试';
    }
  }
  home() {
    this.$router.push('/20260901JQDM/home');
  }
  rank() {
    this.$router.push('/20260901JQDM/rank');
  }
  share() {
    if (isWeiXin()) {
      this.message = '分享内容已准备好，请点击右上角分享';
      window.setTimeout(() => {
        this.message = '';
      }, 2200);
      return;
    }
    if (window.udid && typeof window.openApp === 'function') {
      window.openApp('mShowShare');
      this.message = '正在打开分享';
      window.setTimeout(() => {
        this.message = '';
      }, 1600);
      return;
    }
    this.message = '请在微信或上游新闻App中分享';
    window.setTimeout(() => {
      this.message = '';
    }, 1800);
  }
}
